import type { ButtonHTMLAttributes, InputHTMLAttributes } from 'react';
import { Pencil } from '@gravity-ui/icons';
import { Button } from '@gravity-ui/uikit';

import { UPLOAD_PHOTO } from '../constants';

import styles from '../styles.module.scss';

interface FileEditProps {
	controlProps: InputHTMLAttributes<HTMLInputElement>;
	triggerProps: ButtonHTMLAttributes<HTMLButtonElement>;
	imageSrc?: string;
}

export const FileChange = ({ controlProps, triggerProps, imageSrc }: FileEditProps) => {
	return (
		<>
			<input {...controlProps} style={{ display: 'none' }} />

			{imageSrc ? (
				<button className={styles.profile__img__edit} {...triggerProps}>
					<Pencil />
				</button>
			) : (
				<Button {...triggerProps} view="normal" size="xl">
					{UPLOAD_PHOTO}
				</Button>
			)}
		</>
	);
};
